import appConfig from '@nerdwallet/app-config';

export default {
  title: 'Explore our ethical finance guide',
  subtitle: `Want to make smart, socially responsible financial decisions? We've got articles, videos, podcasts, and more to help you learn how.`,
  backgroundColor: '#00682C',
  ctaButtonText: 'get resources',
  ctaLinkUrl: '/l/ethical-finance',
  visualBackgroundImageUrl: `${appConfig.ASSETS_URL}/images/homepage/banking-house-ad.png`,
  visualBackgroundImageAlt: 'Seedling sprouting out of a pile of coins.',
  elementImpressionEntityName: 'hp_campaign_module', // used for the Impression of the component
  trkQueryParam: 'hp_campaign_module', // used to append to the URL when the button is clicked
};
